import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: `${backendUrl}/data-v1/v1/client`,
  withCredentials: true,
  xsrfCookieName: "csrf_token",
  xsrfHeaderName: "X-CSRF-Token",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

/**
 * Explicitly fetch CSRF token from backend
 */
export const fetchCsrfToken = async () => {
  try {
    const backendBase = process.env.REACT_APP_BACKEND_URL || "";
    await axios.get(`${backendBase}/data-v1/v1/csrf-token`, {
      withCredentials: true,
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to fetch CSRF token:", error);
    }
  }
};

// Add a request interceptor for potential debugging or header injection
api.interceptors.request.use(
  (config) => {
    // Manually extract csrf_token from cookie because axios's xsrfCookieName
    // only works for same-origin requests. Since port 3000 and 8000 are
    // different origins, we must manually inject it for cross-port development.
    if (typeof document !== "undefined") {
      const cookies = document.cookie.split(";");
      const csrfCookie = cookies.find((c) =>
        c.trim().startsWith("csrf_token="),
      );
      if (csrfCookie) {
        const token = csrfCookie.split("=")[1];
        if (token) {
          config.headers["X-CSRF-Token"] = token;
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor to handle global errors (like 401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear local user state if session expired
      // This is often handled by AuthContext, but can be triggered here
      if (process.env.NODE_ENV === "development") {
        console.warn("Session expired or unauthorized");
      }
    }
    return Promise.reject(error);
  },
);

export default api;
